import publishDvrStateChangeService from './service/PublishDvrStateChangeService';
import settingsService from './service/SettingsService';
import * as actionType from './SettingsActionsType';

export const save = (postData, publishStateData, payloadData) => async dispatcher => {
  dispatcher({type: actionType.SAVE_REQUEST});
  try {
    await settingsService.saveSettings(postData);
    dispatcher({type: actionType.SAVE_SUCCESS, payload: payloadData});
    if(publishStateData !== null){
      await publishDvrStateChangeService.publishState(publishStateData);
    }
  } catch (e) {
    console.error('Something went wrong when saving the settings', e);
    dispatcher({type: actionType.SAVE_FAILURE});
  }
};

export const updateDBE = (postData) => async dispatcher => {
  dispatcher({type: actionType.SAVE_DBE_REQUEST});
  try {
    const response = await settingsService.saveDBEPolicy(postData);
    dispatcher({type: actionType.SAVE_DBE_SUCCESS, payload: response.data});

    return response.data;
  } catch (e) {
    console.error('Something went wrong when saving driver behavior events policy', e);
    dispatcher({type: actionType.SAVE_DBE_FAILURE});
  }
};
